import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AngularMaterialModule, LucideModule, SharedModule } from "app/shared";
import { AuthLayoutComponent } from "./auth-layout/auth-layout.component";
import { MainLayoutComponent } from "./main-layout/main-layout.component";
import { MainHeaderComponent } from "./main-layout/main-header/main-header.component";
import { MainFooterComponent } from "./main-layout/main-footer/main-footer.component";
import { AcessibilidadeComponent } from "./main-layout/acessibilidade/acessibilidade.component";
import { RedesSociaisComponent } from "app/features/portal-carta-servico/homepage/redes-sociais/redes-sociais.component";
import { AceiteCookiesComponent } from "./main-layout/aceite-cookies/aceite-cookies.component";
import { TemaComponent } from "./main-layout/tema/tema.component";
import { AvaliacaoAtendimentoComponent } from "app/features/portal-carta-servico/avaliacao-atendimento/avaliacao-atendimento.component";

@NgModule({
  declarations: [
    AuthLayoutComponent,
    MainLayoutComponent,
    MainHeaderComponent,
    MainFooterComponent,
    AcessibilidadeComponent,
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    SharedModule,
    LucideModule,
    RedesSociaisComponent,
    AceiteCookiesComponent,
    AvaliacaoAtendimentoComponent,
    TemaComponent
  ],
  providers: [],
  exports: [
    MainLayoutComponent
  ]
})
export class LayoutModule { }
